module.exports = __webpack_public_path__ + "static/media/29ADMSPC28.8fc6919e.jpg";